var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "paginator clearfix",
      attrs: {
        "aria-label": "Question Selector",
        id: "question-nav",
        tabindex: "-1"
      }
    },
    [
      _c("h2", { staticClass: "paginator-title" }, [_vm._v("Questions:")]),
      _vm._v(" "),
      _vm.testQuestions.length
        ? _c(
            "div",
            { staticClass: "flex-container-wrap" },
            _vm._l(_vm.testQuestions, function(questionId, index) {
              return _c(
                "div",
                {
                  key: index,
                  class:
                    _vm.getClassNames(questionId) +
                    " " +
                    (_vm.isFlagged(questionId) ? "flag" : ""),
                  attrs: {
                    role: "button",
                    tabindex: "0",
                    "aria-label": "Question" + (index + 1)
                  },
                  on: {
                    click: function($event) {
                      return _vm.setActiveQuestionAction(questionId)
                    },
                    keyup: [
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.setActiveQuestionAction(questionId)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar"
                          ])
                        ) {
                          return null
                        }
                        return _vm.setActiveQuestionAction(questionId)
                      }
                    ]
                  }
                },
                [
                  _vm.isFlagged(questionId)
                    ? _c("font-awesome-icon", {
                        attrs: { icon: "flag", "aria-hidden": "true" }
                      })
                    : _vm.isGraded(questionId) && !_vm.isCorrect(questionId)
                    ? _c("font-awesome-icon", {
                        attrs: { icon: "times", "aria-hidden": "true" }
                      })
                    : _c("span", [_vm._v(_vm._s(index + 1))])
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "text-center submit" }, [
        !_vm.reviewMode
          ? _c(
              "button",
              {
                class: [
                  "btn btn-light-blue",
                  { disabled: !_vm.activeQuestionId }
                ],
                attrs: {
                  role: "button",
                  tabindex: "0",
                  "arial-label": "Submit Test"
                },
                on: {
                  click: function($event) {
                    return _vm.jumpToSubmit()
                  }
                }
              },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: "arrow-alt-circle-up" }
                }),
                _vm._v(
                  " \n\t\t\t" +
                    _vm._s(
                      _vm.$t("MAIN_CONTENT.testButtons.takeTester_submitTest")
                    ) +
                    "\n\t\t"
                )
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }